<template>
  <div
    class="tab_option"
    @mouseenter="showList"
    @mouseleave="hideList"
  >
    <a
      :class="{option_list_one: true, span_tag: true}"
      @click="haddleSelectField(data)"
    >
      <i
        class="iconfont on"
        v-if="is_active(data.id)"
      >&#xe64b;</i><i
        class="iconfont"
        v-if="!is_active(data.id) && !indeterminate"
      >&#xe64a;</i><i
        class="iconfont ind"
        v-if="indeterminate && !is_active(data.id)"
      >&#xef52;</i>{{data.name}}
      <Icon
        type="ios-arrow-up"
        v-if="show_option_list && data.children.length > 0"
      />
      <Icon
        type="ios-arrow-down"
        v-if="!show_option_list && data.children.length > 0"
      /></a>
    <div
      class="option_list"
      v-show="show_option_list && data.children.length > 0"
    >
      <div class="option_bg">
        <ul class="option_list_two">
          <li
            v-for="(item,index) in data.children"
            @click="haddleSelectField(item)"
          >
            <label
              class="ivu-checkbox-wrapper"
            >
              <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': is_active(item.id)}">
                <span class="ivu-checkbox-inner"></span>
              </span>
              <span>{{item.name}}</span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { idxOf } from 'js/findIndex'
import { attention_mixins } from 'js/attention_mixins'
export default {
  name: 'TabOption',
  mixins: [attention_mixins],
  props: ['data'],
  data() {
    return {
      show_option_list: false
    }
  },
  computed: {
    group_subscribe() {
      let g_subscribe = this.attention.subscribe.filter(item => item.sub_type == '20')
      return g_subscribe
    },
    is_active() {
      return function (id) {
        return this.group_subscribe.findIndex(item => item.sub_type_id == id) > -1
      }
    },
    indeterminate() {
      let len = 0
      this.data.children.map(a => {
        let index = this.group_subscribe.findIndex(item => item.sub_type_id == a.id)
        if (index > -1) {
          len++
        }
      })
      return len > 0
    }
  },
  methods: {
    haddleSelectField(item) {
      _czc.push(['_trackEvent', '动脉橙快讯关注', '关注领域内容点击_' + this.data.name])
      this.$emit('selectField', item.id, this.is_active(item.id))
    },
    showList() {
      this.show_option_list = true
    },
    hideList() {
      this.show_option_list = false
    }
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.tab_option
  position: relative
  display: inline-block
  margin: 0 10px 10px 0
  .option_list_one
    commonBgColor(#35383F, #F9F9F9)
    padding: 10px 12px
    commonColor(#E9E9EB, #333333)
    border: 1px solid
    commonBorderColor(#35383F, #F9F9F9)
    line-height 16px
    &:hover
      border-color: #FA5A00
    &.on
      color: #FA5A00
    i
      font-size: 16px
      display: inline-block
      vertical-align: top
      margin-right: 8px
      commonColor(#BCBDC1, #AAAAAA)
      &.on
      &.ind
        color: #49b580
      &.ivu-icon
        margin-right 0
        margin-left 6px
  .option_list
    position: absolute
    top: 32px
    padding: 6px 0
    z-index: 101
    .option_bg
      .option_list_two
      .option_list_thr
        padding: 9px 0
        height: 180px
        overflow: auto
        commonBgColor(#2D2F34, #FFF)
        box-shadow: 4px 4px 10px 0 rgba(0,0,0,0.50)
        li
          padding: 9px 12px
          font-size: 12px
          commonColor(#E9E9EB, #333333)
          cursor: pointer
          line-height: 16px
          transition_02s()
          &.on
            color: #FA5A00
          &:hover
            commonBgColor(#35383F, #F9F9F9) 
        &::-webkit-scrollbar-track
          border: 0
          background-color: transparent
        &::-webkit-scrollbar
          width: 4px
          background-color: transparent
        &::-webkit-scrollbar-thumb
          background-color: rgba(255,255,255,0.20)
          border-radius: 2px
      .option_list_thr
        position: absolute
        left: 136px
        top: 6px
        width: 140px
        border-left: 2px solid #464952
      .option_list_two
        width: 136px
        overflow: auto
        li
          padding 0
          position: relative
          .ivu-checkbox-wrapper
            font-size: 0
            padding: 9px 12px
            margin 0
            display: flex
            & >>> .ivu-checkbox
              font-size: 0
              margin-right: 4px
              .ivu-checkbox-inner
                display: inline-block
                vertical-align: top
                background: transparent
                margin-right 2px
                commonBorderColor(#7A7F94, #D5D5D5)
              &:hover
                .ivu-checkbox-inner
                  commonBorderColor(rgba(250, 122, 80, 1), #23294D)
              &-focus
                box-shadow: none
              &.ivu-checkbox-checked
                .ivu-checkbox-inner
                  commonBorderColor(rgba(250, 122, 80, 1), #23294D)
                  commonBgColor(rgba(250, 122, 80, 1), #23294D)
            span.ivu-checkbox+*
              font-size: 12px
              vertical-align: top
              line-height: 14px
              margin-right: 0
              commonColor(#FFFFFF, #666666)
              &:hover
                color: rgba(250, 122, 80, 1) !important

</style>
